export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** AIFilterRegex */
  AIFilterRegex: { input: string; output: string; }
  /** Integer beyond the 32-bit range, limited to ±(2^53 - 1) and serialized as a number */
  BigInt: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  /** JSON string */
  JSON: { input: any; output: any; }
  /** Lexical JSON */
  LexicalJSON: { input: any; output: any; }
  /** ULID */
  ULID: { input: string; output: string; }
};

export type AiFilter = {
  __typename?: 'AIFilter';
  collections: Array<CustomCollection>;
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  passValue: AiFilterPassValue;
  prompt: Scalars['String']['output'];
};

export const AiFilterAssistantResponseType = {
  ClarificationRequired: 'CLARIFICATION_REQUIRED',
  Complete: 'COMPLETE'
} as const;

export type AiFilterAssistantResponseType = typeof AiFilterAssistantResponseType[keyof typeof AiFilterAssistantResponseType];
export type AiFilterEvaluation = {
  __typename?: 'AIFilterEvaluation';
  comment: Scalars['String']['output'];
  qualityLevel: AiFilterQualityLevel;
};

export type AiFilterInput = {
  model: Scalars['String']['input'];
  name: Scalars['String']['input'];
  passValue: AiFilterPassValue;
  prompt: Scalars['String']['input'];
};

export const AiFilterPassValue = {
  No: 'NO',
  Yes: 'YES'
} as const;

export type AiFilterPassValue = typeof AiFilterPassValue[keyof typeof AiFilterPassValue];
export const AiFilterQualityLevel = {
  High: 'HIGH',
  Low: 'LOW',
  Medium: 'MEDIUM'
} as const;

export type AiFilterQualityLevel = typeof AiFilterQualityLevel[keyof typeof AiFilterQualityLevel];
export type AiFilterSuggestion = {
  __typename?: 'AIFilterSuggestion';
  chatId: Scalars['ID']['output'];
  passValue: AiFilterPassValue;
  prompt: Scalars['String']['output'];
  responseType: AiFilterAssistantResponseType;
};

/** Input for testing an AI filter */
export type AiFilterTestInput = {
  /** The model to use for the filter */
  model: Scalars['String']['input'];
  passValue: AiFilterPassValue;
  prompt: Scalars['String']['input'];
};

export type AddCustomCollectionInput = {
  filters: CustomCollectionFilterConfigInput;
  highlights?: InputMaybe<CustomCollectionHighlightInput>;
  name: Scalars['String']['input'];
  sources: Array<CustomCollectionSourceInput>;
  streamDeckId: Scalars['ULID']['input'];
};

export type AddStreamDeckInput = {
  name: Scalars['String']['input'];
};

export type AddTerminalTabInput = {
  configuration: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AdminAdjustPointsResult = {
  __typename?: 'AdminAdjustPointsResult';
  newBalance: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type AllStreamsPostsSearchInput = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  streamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApiKeyCanReadInput = {
  mode: ApiKeyCanReadMode;
  streamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export const ApiKeyCanReadMode = {
  All: 'ALL',
  Specific: 'SPECIFIC'
} as const;

export type ApiKeyCanReadMode = typeof ApiKeyCanReadMode[keyof typeof ApiKeyCanReadMode];
export type ApiKeyPermissionsObject = {
  __typename?: 'ApiKeyPermissionsObject';
  canPublish: Array<Stream>;
  canPublishSources: Array<Scalars['ID']['output']>;
  canRead: Array<Stream>;
  canReadAll: Scalars['Boolean']['output'];
};

export type Award = {
  __typename?: 'Award';
  medal: Medal;
  medalId: Scalars['ID']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type AwardInput = {
  medalId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type BottomAction = {
  __typename?: 'BottomAction';
  href: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ChatKitSession = {
  __typename?: 'ChatKitSession';
  clientSecret: Scalars['String']['output'];
};

export type CompletedMilestone = {
  __typename?: 'CompletedMilestone';
  completedAt: Scalars['String']['output'];
  pointsAwarded: Scalars['Int']['output'];
  type: LearningMilestoneType;
};

export type CreateOAuthCodeInput = {
  accessToken: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStreamInvitesInput = {
  emails: Array<Scalars['String']['input']>;
  inviteeIds: Array<Scalars['ID']['input']>;
  streamId: Scalars['ID']['input'];
};

export type CustomCollection = Node & {
  __typename?: 'CustomCollection';
  columnWidth?: Maybe<Scalars['Int']['output']>;
  filters: CustomCollectionFilterConfig;
  highlights?: Maybe<CustomCollectionHighlight>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sourceConfigs: Array<CustomCollectionSourceConfig>;
  sources: Array<Stream>;
};

export type CustomCollectionFilterConfig = {
  __typename?: 'CustomCollectionFilterConfig';
  ai?: Maybe<AiFilter>;
  excludeKeywords?: Maybe<CustomCollectionKeywordFilterConfig>;
  highlightColor?: Maybe<Scalars['String']['output']>;
  includeKeywords?: Maybe<CustomCollectionKeywordFilterConfig>;
  isHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  regex?: Maybe<Scalars['String']['output']>;
};

export type CustomCollectionFilterConfigInput = {
  ai?: InputMaybe<Scalars['ULID']['input']>;
  excludeKeywords?: InputMaybe<CustomCollectionKeywordFilterConfigInput>;
  highlightColor?: InputMaybe<Scalars['String']['input']>;
  includeKeywords?: InputMaybe<CustomCollectionKeywordFilterConfigInput>;
  isHighlightEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  regex?: InputMaybe<Scalars['AIFilterRegex']['input']>;
};

export type CustomCollectionHighlight = {
  __typename?: 'CustomCollectionHighlight';
  isEnabled: Scalars['Boolean']['output'];
  values: Array<CustomCollectionHighlightValue>;
};

export type CustomCollectionHighlightInput = {
  isEnabled: Scalars['Boolean']['input'];
  values: Array<CustomCollectionHighlightValueInput>;
};

export type CustomCollectionHighlightValue = {
  __typename?: 'CustomCollectionHighlightValue';
  color: Scalars['String']['output'];
  regex: Scalars['String']['output'];
};

export type CustomCollectionHighlightValueInput = {
  color: Scalars['String']['input'];
  regex: Scalars['String']['input'];
};

export type CustomCollectionKeywordFilterConfig = {
  __typename?: 'CustomCollectionKeywordFilterConfig';
  all?: Maybe<Scalars['String']['output']>;
  any?: Maybe<Scalars['String']['output']>;
  phrase?: Maybe<Scalars['String']['output']>;
};

export type CustomCollectionKeywordFilterConfigInput = {
  all?: InputMaybe<Scalars['String']['input']>;
  any?: InputMaybe<Scalars['String']['input']>;
  phrase?: InputMaybe<Scalars['String']['input']>;
};

export type CustomCollectionPostUpdate = {
  __typename?: 'CustomCollectionPostUpdate';
  post: StreamPost;
};

export type CustomCollectionPostsPage = {
  __typename?: 'CustomCollectionPostsPage';
  items: Array<StreamPost>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type CustomCollectionSourceConfig = {
  __typename?: 'CustomCollectionSourceConfig';
  customTargets: Array<Scalars['String']['output']>;
  stream: Stream;
  usesAllTargets: Scalars['Boolean']['output'];
};

export type CustomCollectionSourceInput = {
  customTargets?: InputMaybe<Array<Scalars['String']['input']>>;
  streamId: Scalars['ID']['input'];
};

export type CustomTargetsCheckoutData = {
  quantity: Scalars['Int']['input'];
};

export type CustomTargetsData = {
  __typename?: 'CustomTargetsData';
  maxTargets: Scalars['Int']['output'];
  maxTotalTargets?: Maybe<Scalars['Int']['output']>;
  minTargets: Scalars['Int']['output'];
  stepSize: Scalars['Int']['output'];
  targetType: Scalars['String']['output'];
  targetTypeInstruction: Scalars['String']['output'];
  targetValidationRegex?: Maybe<Scalars['String']['output']>;
};

export type CustomTargetsDataInput = {
  maxTargets: Scalars['Int']['input'];
  maxTotalTargets?: InputMaybe<Scalars['Int']['input']>;
  minTargets: Scalars['Int']['input'];
  stepSize: Scalars['Int']['input'];
  targetType: Scalars['String']['input'];
  targetTypeInstruction: Scalars['String']['input'];
  targetValidationRegex?: InputMaybe<Scalars['String']['input']>;
};

export type DiscussionPage = {
  __typename?: 'DiscussionPage';
  items: Array<DiscussionPost>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type DiscussionPost = IPost & Node & {
  __typename?: 'DiscussionPost';
  author: User;
  authorId: Scalars['ID']['output'];
  comments: DiscussionPage;
  commentsCount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  discussionContextId: Scalars['ID']['output'];
  discussionContextStream?: Maybe<Stream>;
  discussionContextTournament?: Maybe<Tournament>;
  discussionLevel: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  json?: Maybe<Scalars['String']['output']>;
  markdown?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<S3Object>>;
  parentDiscussionPostId?: Maybe<Scalars['ID']['output']>;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type DiscussionPostCommentsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type DiscussionPostInput = {
  discussionContextId: Scalars['ID']['input'];
  json?: InputMaybe<Scalars['String']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<S3ObjectInput>>;
  parentDiscussionPostId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type EnrichmentInvocation = {
  __typename?: 'EnrichmentInvocation';
  error?: Maybe<Scalars['String']['output']>;
  inputBytes: Scalars['Int']['output'];
  inputPreview: Scalars['String']['output'];
  latencyMs: Scalars['Int']['output'];
  outcome: EnrichmentInvocationOutcome;
  postId?: Maybe<Scalars['String']['output']>;
  responseBytes: Scalars['Int']['output'];
  resultPreview?: Maybe<Scalars['String']['output']>;
  service: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  ts: Scalars['String']['output'];
};

export const EnrichmentInvocationOutcome = {
  BreakerOpen: 'breaker_open',
  Error: 'error',
  Ok: 'ok',
  Shed: 'shed',
  Timeout: 'timeout'
} as const;

export type EnrichmentInvocationOutcome = typeof EnrichmentInvocationOutcome[keyof typeof EnrichmentInvocationOutcome];
export type EnrichmentInvocationPage = {
  __typename?: 'EnrichmentInvocationPage';
  items: Array<EnrichmentInvocation>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type EnrichmentLatencyBands = {
  __typename?: 'EnrichmentLatencyBands';
  gt3000: Scalars['Int']['output'];
  le100: Scalars['Int']['output'];
  le250: Scalars['Int']['output'];
  le500: Scalars['Int']['output'];
  le1000: Scalars['Int']['output'];
  le2000: Scalars['Int']['output'];
  le3000: Scalars['Int']['output'];
};

export type EnrichmentLatencyBucket = {
  __typename?: 'EnrichmentLatencyBucket';
  approxP95Ms?: Maybe<Scalars['Float']['output']>;
  avgMs: Scalars['Float']['output'];
  bands: EnrichmentLatencyBands;
  bucketStart: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  maxMs: Scalars['Int']['output'];
  outcomes: EnrichmentLatencyOutcomes;
};

export type EnrichmentLatencyOutcomes = {
  __typename?: 'EnrichmentLatencyOutcomes';
  breakerOpen: Scalars['Int']['output'];
  error: Scalars['Int']['output'];
  ok: Scalars['Int']['output'];
  shed: Scalars['Int']['output'];
  timeout: Scalars['Int']['output'];
};

export type EnrichmentService = {
  __typename?: 'EnrichmentService';
  createdAt: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  maxResponseBytes: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  secretArn?: Maybe<Scalars['String']['output']>;
  timeoutMs: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type EnrichmentServiceName = {
  __typename?: 'EnrichmentServiceName';
  name: Scalars['String']['output'];
};

export type EnrichmentsObject = {
  __typename?: 'EnrichmentsObject';
  polymatcher?: Maybe<Array<Scalars['String']['output']>>;
  translate?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseNodeData = {
  __typename?: 'EnterpriseNodeData';
  az: Scalars['String']['output'];
  ip: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type EnterpriseStreamPost = {
  __typename?: 'EnterpriseStreamPost';
  createdAt: Scalars['String']['output'];
  leaf: EnterpriseNodeData;
  pk: Scalars['String']['output'];
  post: EnterpriseStreamPostData;
  root: EnterpriseNodeData;
  sk: Scalars['String']['output'];
  streamId: Scalars['String']['output'];
};

export type EnterpriseStreamPostData = {
  __typename?: 'EnterpriseStreamPostData';
  idempotencyKey: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type EnterpriseStreamPostsPage = {
  __typename?: 'EnterpriseStreamPostsPage';
  items: Array<EnterpriseStreamPost>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export const Exchange = {
  BinancePerps: 'BINANCE_PERPS',
  BinanceSpot: 'BINANCE_SPOT',
  BybitPerps: 'BYBIT_PERPS',
  BybitSpot: 'BYBIT_SPOT',
  HypePerps: 'HYPE_PERPS',
  HypeSpot: 'HYPE_SPOT',
  Kalshi: 'KALSHI',
  Polymarket: 'POLYMARKET'
} as const;

export type Exchange = typeof Exchange[keyof typeof Exchange];
export type ExchangeOAuthCodeInput = {
  code: Scalars['String']['input'];
};

export type ExchangePairInput = {
  exchange: Exchange;
  value: Scalars['String']['input'];
};

export type ExchangePairObject = {
  __typename?: 'ExchangePairObject';
  exchange: Exchange;
  value: Scalars['String']['output'];
};

export type ExportEnterpriseStreamPostsInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  leafAz?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['ID']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type ExportStreamPostsInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['ID']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type FieldDefinition = {
  __typename?: 'FieldDefinition';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: FieldType;
  validations: FieldValidations;
};

export type FieldDefinitionInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: FieldType;
  validations: FieldValidationsInput;
};

export const FieldType = {
  Media: 'MEDIA',
  Percentage: 'PERCENTAGE',
  RichText: 'RICH_TEXT'
} as const;

export type FieldType = typeof FieldType[keyof typeof FieldType];
export type FieldValidations = {
  __typename?: 'FieldValidations';
  required: Scalars['Boolean']['output'];
};

export type FieldValidationsInput = {
  required: Scalars['Boolean']['input'];
};

export type FieldValue = {
  __typename?: 'FieldValue';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FieldValueInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Flag = {
  __typename?: 'Flag';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type HoldStreamInput = {
  description: Scalars['String']['input'];
};

export type IOffsetPage = {
  items: Array<Node>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type IPost = {
  authorId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  media?: Maybe<Array<S3Object>>;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type IconInput = {
  url: Scalars['String']['input'];
};

export type IconObject = {
  __typename?: 'IconObject';
  url: Scalars['String']['output'];
};

export type InAppNotificationContent = {
  __typename?: 'InAppNotificationContent';
  bottomActions?: Maybe<Array<BottomAction>>;
  htmlBody?: Maybe<Scalars['String']['output']>;
  htmlTitle?: Maybe<Scalars['String']['output']>;
  image?: Maybe<NotificationImage>;
  jsonBody?: Maybe<Scalars['JSON']['output']>;
  toggleFollowUserButton?: Maybe<ToggleFollowUserButton>;
};

export type KeysInput = {
  auth: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
};

export type KeysType = {
  __typename?: 'KeysType';
  auth: Scalars['String']['output'];
  p256dh: Scalars['String']['output'];
};

export type LearningMilestoneInfo = {
  __typename?: 'LearningMilestoneInfo';
  completed: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  pointsReward: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: LearningMilestoneType;
};

export const LearningMilestoneType = {
  FirstPurchase: 'FIRST_PURCHASE',
  FirstStreamdeckList: 'FIRST_STREAMDECK_LIST',
  VideoWatched: 'VIDEO_WATCHED'
} as const;

export type LearningMilestoneType = typeof LearningMilestoneType[keyof typeof LearningMilestoneType];
export type LearningProgress = {
  __typename?: 'LearningProgress';
  availableMilestones: Array<LearningMilestoneInfo>;
  availablePoints: Scalars['Int']['output'];
  completedMilestones: Array<CompletedMilestone>;
  videos: Array<LearningVideo>;
};

export type LearningVideo = {
  __typename?: 'LearningVideo';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  pointsReward: Scalars['Int']['output'];
  s3Key: Scalars['String']['output'];
  title: Scalars['String']['output'];
  watched: Scalars['Boolean']['output'];
};

export type Medal = Node & {
  __typename?: 'Medal';
  description?: Maybe<Scalars['String']['output']>;
  durationDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<S3Object>;
  money?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  upvotesReward?: Maybe<Scalars['Int']['output']>;
  votePowerReward?: Maybe<Scalars['Int']['output']>;
};

export type MedalInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<S3ObjectInput>;
  money?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  upvotesReward?: InputMaybe<Scalars['Int']['input']>;
  votePowerReward?: InputMaybe<Scalars['Int']['input']>;
};

export type MedalsPage = {
  __typename?: 'MedalsPage';
  items: Array<Medal>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type MediaItemInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type MediaItemObject = {
  __typename?: 'MediaItemObject';
  caption?: Maybe<Scalars['String']['output']>;
  credit?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MediaUploadUrl = {
  __typename?: 'MediaUploadUrl';
  /** Object key suffix echoed back from the request */
  key: Scalars['String']['output'];
  /** Pre-signed S3 PUT URL, valid for 60 minutes */
  url: Scalars['String']['output'];
};

export type MediaUploadUrlInput = {
  /** file mime type */
  contentType: Scalars['String']['input'];
  /** Object key suffix (without the server-enforced prefix) */
  key: Scalars['String']['input'];
};

export type MetadataInput = {
  headline?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<IconInput>;
  machineReadableText?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<MediaItemInput>>;
  pairs?: InputMaybe<Array<ExchangePairInput>>;
  sourceLink?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceTimestamp?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRejectReason?: InputMaybe<Scalars['String']['input']>;
  targetUnRejectReason?: InputMaybe<Scalars['String']['input']>;
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataObject = {
  __typename?: 'MetadataObject';
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<IconObject>;
  machineReadableText?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<MediaItemObject>>;
  pairs?: Maybe<Array<ExchangePairObject>>;
  sourceLink?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceTimestamp?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tickers?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  OpticFeedsTwttrMutation: OpticFeedsTwttrMutation;
  acceptPrivacyPolicy: User;
  acceptTermsOfService: User;
  activateStream: Stream;
  addAIFilter: AiFilter;
  addCustomCollection: CustomCollection;
  addDiscussionPost: DiscussionPost;
  addMedal: Medal;
  addMedalToTournament: Tournament;
  addOrganization: OrganizationObject;
  addPost: RegularPost;
  addPushNotificationsSubscription: Scalars['Boolean']['output'];
  addSourceRoute: Source;
  addSourceToApiKey: StreamApiKey;
  addStream: Stream;
  addStreamDeck: StreamDeck;
  addStreamPackage: StreamPackage;
  addStreamPost: StreamPost;
  addStreamToApiKey: StreamApiKey;
  addTerminalTab: TerminalTab;
  addTournament: Tournament;
  addTournamentPost: TournamentPost;
  addUserToEarlyAccessTerminal: Scalars['Boolean']['output'];
  addUsersToOrganization: Array<User>;
  addUsersToStream: Array<User>;
  adminAdjustRewardPoints: AdminAdjustPointsResult;
  aiFilterWithAssistant: AiFilterSuggestion;
  createChatKitSession: ChatKitSession;
  createOAuthCode: OAuthCode;
  createOrganizationUser: Scalars['Boolean']['output'];
  createSource: Source;
  createStreamInvites: Array<StreamInvite>;
  createStripeSellerAccount: StripeSellerAccount;
  deactivateStream: Stream;
  deleteEnrichmentService: Scalars['Boolean']['output'];
  deleteMedalFromTournament: Tournament;
  deleteOrganization: Scalars['Boolean']['output'];
  deleteSource: Scalars['Boolean']['output'];
  deleteStream: Scalars['Boolean']['output'];
  deleteStreamPackage: Scalars['Boolean']['output'];
  exchangeOAuthCode: OAuthTokens;
  follow: Scalars['Boolean']['output'];
  followStream: Scalars['Boolean']['output'];
  generateApiKey: Scalars['String']['output'];
  generatePossibleUsernames: Array<Scalars['String']['output']>;
  grantStreamAccessToOrganization: OrganizationObject;
  holdStream: Stream;
  markLearningVideoWatched: LearningProgress;
  mediaUploadUrl: MediaUploadUrl;
  polymatcherExplain: PolymatcherExplainResult;
  polymatcherRefreshUserActions: PolymatcherUserActionRefreshReport;
  polymatcherSetLabel: PolymatcherSetLabelResult;
  polymatcherSetManualLabel: PolymatcherSetLabelResult;
  polymatcherSetUserActionLabel: PolymatcherSetLabelResult;
  publishStream: Stream;
  readAllNotifications: Scalars['Boolean']['output'];
  readNotification: Notification;
  redeemLearningPoints: RedeemPointsResult;
  regenerateApiKey: Scalars['String']['output'];
  removeAIFilter: Scalars['Boolean']['output'];
  removeCustomCollection: Scalars['Boolean']['output'];
  removeOpenAIKey: Scalars['Boolean']['output'];
  removePushNotificationsSubscription: Scalars['Boolean']['output'];
  removeSourceFromApiKey: StreamApiKey;
  removeSourceRoute: Source;
  removeStreamDeck: Scalars['Boolean']['output'];
  removeStreamFromApiKey: StreamApiKey;
  removeTerminalTab: Scalars['Boolean']['output'];
  removeUserFromEarlyAccessTerminal: Scalars['Boolean']['output'];
  removeUserFromOrganization: Scalars['Boolean']['output'];
  removeUserFromStream: User;
  removeXComHandle: User;
  renameApiKey: StreamApiKey;
  repost: RePost;
  requestTerminalAccess: User;
  resolveStreamInvite: Scalars['Boolean']['output'];
  reviewVoxFullAccessRequest: VoxFullAccessRequest;
  revokeStreamAccessFromOrganization: OrganizationObject;
  revokeStreamApiKey: Scalars['Boolean']['output'];
  savePostMarketAddMarketSignal: PostMarketAddMarketSignal;
  savePostMarketButtonSignal: PostMarketSignal;
  setAuthorHighlighted: User;
  setCustomCollectionColumnWidth: CustomCollection;
  setEnrichmentServiceEnabled: EnrichmentService;
  setOpenAIKey: OpenAiKey;
  setStreamCustomTargets: Array<Scalars['String']['output']>;
  setStreamFeatured: Stream;
  setStreamFollowExpiration: Scalars['Boolean']['output'];
  setStreamPackageFeatured: StreamPackage;
  setUsername: User;
  setXComHandle: User;
  streamPackageSubscriptionCancel: StreamPackageSubscription;
  streamPackageSubscriptionCheckout: SubscriptionCheckout;
  streamSubscriptionCancel: StreamSubscription;
  streamSubscriptionCheckout: SubscriptionCheckout;
  streamSubscriptionUpdate: Scalars['Boolean']['output'];
  submitVoxFullAccessRequest: VoxFullAccessRequest;
  subscribeToUserPosts: Scalars['Boolean']['output'];
  unRepost: Scalars['Boolean']['output'];
  unfollow: Scalars['Boolean']['output'];
  unfollowStream: Scalars['Boolean']['output'];
  unsubscribeFromUserPosts: Scalars['Boolean']['output'];
  updateAIFilter: AiFilter;
  updateApiKeyPermissions: StreamApiKey;
  updateCustomCollection: CustomCollection;
  updateCustomCollectionSortOrder: Array<Scalars['String']['output']>;
  updateGeneralNotificationSettings: UserSettings;
  updateOrganization: OrganizationObject;
  updateOrganizationUserRole: User;
  updatePost: RegularPost;
  updateSettings: UserSettings;
  updateSource: Source;
  /** Updates a route. delayMs is replaced on every call (omitting it clears the delay); enterprise is only changed when provided; enrichments only when provided (empty array clears). */
  updateSourceRoute: Source;
  updateStream: Stream;
  updateStreamDeck: StreamDeck;
  updateStreamDeckSortOrder: Array<Scalars['String']['output']>;
  updateStreamPackage: StreamPackage;
  updateTerminalSettings: TerminalSettings;
  updateTerminalTab: TerminalTab;
  updateTerminalTabSortOrder: Array<Scalars['String']['output']>;
  updateTournament: Tournament;
  updateUser: User;
  upsertEnrichmentService: EnrichmentService;
  voxSubscriptionCancel: VoxSubscription;
  voxSubscriptionCheckout: SubscriptionCheckout;
  voxSubscriptionUpgrade: VoxSubscription;
};


export type MutationActivateStreamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddAiFilterArgs = {
  input: AiFilterInput;
};


export type MutationAddCustomCollectionArgs = {
  input: AddCustomCollectionInput;
};


export type MutationAddDiscussionPostArgs = {
  input: DiscussionPostInput;
};


export type MutationAddMedalArgs = {
  input: MedalInput;
};


export type MutationAddMedalToTournamentArgs = {
  medalId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};


export type MutationAddOrganizationArgs = {
  input: OrganizationInput;
};


export type MutationAddPostArgs = {
  input: RegularPostInput;
};


export type MutationAddPushNotificationsSubscriptionArgs = {
  input: PushNotificationSubscriptionInput;
};


export type MutationAddSourceRouteArgs = {
  delayMs?: InputMaybe<Scalars['Int']['input']>;
  enrichments?: InputMaybe<Array<SourceRouteEnrichmentInput>>;
  enterprise?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
  wsMarkdownTemplate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddSourceToApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationAddStreamArgs = {
  input: StreamInput;
};


export type MutationAddStreamDeckArgs = {
  input: AddStreamDeckInput;
};


export type MutationAddStreamPackageArgs = {
  input: StreamPackageInput;
};


export type MutationAddStreamPostArgs = {
  input: StreamPostInput;
};


export type MutationAddStreamToApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};


export type MutationAddTerminalTabArgs = {
  input: AddTerminalTabInput;
};


export type MutationAddTournamentArgs = {
  input: TournamentInput;
};


export type MutationAddTournamentPostArgs = {
  input: TournamentPostInput;
};


export type MutationAddUserToEarlyAccessTerminalArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationAddUsersToOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  role?: OrganizationRoles;
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationAddUsersToStreamArgs = {
  streamId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminAdjustRewardPointsArgs = {
  amount: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationAiFilterWithAssistantArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  prompt: Scalars['String']['input'];
};


export type MutationCreateOAuthCodeArgs = {
  input: CreateOAuthCodeInput;
};


export type MutationCreateOrganizationUserArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateSourceArgs = {
  name: Scalars['String']['input'];
  schema?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateStreamInvitesArgs = {
  input: CreateStreamInvitesInput;
};


export type MutationDeactivateStreamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEnrichmentServiceArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteMedalFromTournamentArgs = {
  medalId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSourceArgs = {
  sourceId: Scalars['ID']['input'];
};


export type MutationDeleteStreamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStreamPackageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExchangeOAuthCodeArgs = {
  input: ExchangeOAuthCodeInput;
};


export type MutationFollowArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationFollowStreamArgs = {
  streamId: Scalars['ID']['input'];
};


export type MutationGenerateApiKeyArgs = {
  canPublish?: Array<Scalars['ID']['input']>;
  canPublishSources?: Array<Scalars['ID']['input']>;
  canRead: ApiKeyCanReadInput;
  keyName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGrantStreamAccessToOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationHoldStreamArgs = {
  id: Scalars['ID']['input'];
  input: HoldStreamInput;
};


export type MutationMarkLearningVideoWatchedArgs = {
  videoId: Scalars['String']['input'];
};


export type MutationMediaUploadUrlArgs = {
  input: MediaUploadUrlInput;
};


export type MutationPolymatcherExplainArgs = {
  input: PolymatcherExplainInput;
};


export type MutationPolymatcherSetLabelArgs = {
  input: PolymatcherSetLabelInput;
};


export type MutationPolymatcherSetManualLabelArgs = {
  input: PolymatcherSetManualLabelInput;
};


export type MutationPolymatcherSetUserActionLabelArgs = {
  input: PolymatcherSetUserActionLabelInput;
};


export type MutationPublishStreamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReadNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRedeemLearningPointsArgs = {
  points: Scalars['Int']['input'];
};


export type MutationRegenerateApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
};


export type MutationRemoveAiFilterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCustomCollectionArgs = {
  id: Scalars['ID']['input'];
  streamDeckId: Scalars['ID']['input'];
};


export type MutationRemovePushNotificationsSubscriptionArgs = {
  input: PushNotificationSubscriptionInput;
};


export type MutationRemoveSourceFromApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationRemoveSourceRouteArgs = {
  routeId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationRemoveStreamDeckArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveStreamFromApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};


export type MutationRemoveTerminalTabArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUserFromEarlyAccessTerminalArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromStreamArgs = {
  streamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRenameApiKeyArgs = {
  apiKeyId: Scalars['ID']['input'];
  keyName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRepostArgs = {
  input: RePostInput;
};


export type MutationResolveStreamInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReviewVoxFullAccessRequestArgs = {
  approved: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRevokeStreamAccessFromOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};


export type MutationRevokeStreamApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSavePostMarketAddMarketSignalArgs = {
  input: PostMarketAddMarketSignalInput;
};


export type MutationSavePostMarketButtonSignalArgs = {
  input: PostMarketButtonSignalInput;
};


export type MutationSetAuthorHighlightedArgs = {
  id: Scalars['ID']['input'];
  isHighlighted: Scalars['Boolean']['input'];
};


export type MutationSetCustomCollectionColumnWidthArgs = {
  collectionId: Scalars['ID']['input'];
  streamDeckId: Scalars['ID']['input'];
  width: Scalars['Int']['input'];
};


export type MutationSetEnrichmentServiceEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};


export type MutationSetOpenAiKeyArgs = {
  enabled: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
};


export type MutationSetStreamCustomTargetsArgs = {
  id: Scalars['ID']['input'];
  input: SetStreamCustomTargetsInput;
};


export type MutationSetStreamFeaturedArgs = {
  id: Scalars['ID']['input'];
  isFeatured: Scalars['Boolean']['input'];
};


export type MutationSetStreamFollowExpirationArgs = {
  input: SetStreamFollowExpirationInput;
};


export type MutationSetStreamPackageFeaturedArgs = {
  id: Scalars['ID']['input'];
  isFeatured: Scalars['Boolean']['input'];
};


export type MutationSetUsernameArgs = {
  username: Scalars['String']['input'];
};


export type MutationSetXComHandleArgs = {
  code: Scalars['String']['input'];
};


export type MutationStreamPackageSubscriptionCancelArgs = {
  input: StreamPackageSubscriptionCancelInput;
};


export type MutationStreamPackageSubscriptionCheckoutArgs = {
  priceId: Scalars['String']['input'];
  redeemPoints?: InputMaybe<Scalars['Int']['input']>;
  streamPackageId: Scalars['ID']['input'];
};


export type MutationStreamSubscriptionCancelArgs = {
  input: StreamSubscriptionCancelInput;
};


export type MutationStreamSubscriptionCheckoutArgs = {
  couponId?: InputMaybe<Scalars['String']['input']>;
  customTargetsCheckoutData?: InputMaybe<CustomTargetsCheckoutData>;
  priceId: Scalars['String']['input'];
  redeemPoints?: InputMaybe<Scalars['Int']['input']>;
  streamId: Scalars['ID']['input'];
};


export type MutationStreamSubscriptionUpdateArgs = {
  customTargetsCheckoutData: CustomTargetsCheckoutData;
  streamId: Scalars['ID']['input'];
};


export type MutationSubmitVoxFullAccessRequestArgs = {
  input: SubmitVoxFullAccessRequestInput;
};


export type MutationSubscribeToUserPostsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUnRepostArgs = {
  repostId: Scalars['ID']['input'];
};


export type MutationUnfollowArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUnfollowStreamArgs = {
  streamId: Scalars['ID']['input'];
};


export type MutationUnsubscribeFromUserPostsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUpdateAiFilterArgs = {
  id: Scalars['ID']['input'];
  input: AiFilterInput;
};


export type MutationUpdateApiKeyPermissionsArgs = {
  apiKeyId: Scalars['ID']['input'];
  canPublish: Array<Scalars['ID']['input']>;
  canRead: ApiKeyCanReadInput;
};


export type MutationUpdateCustomCollectionArgs = {
  input: UpdateCustomCollectionInput;
};


export type MutationUpdateCustomCollectionSortOrderArgs = {
  sortOrder: Array<Scalars['String']['input']>;
  streamDeckId: Scalars['ID']['input'];
};


export type MutationUpdateGeneralNotificationSettingsArgs = {
  input: UpdateGeneralNotificationSettingsInput;
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: OrganizationInput;
};


export type MutationUpdateOrganizationUserRoleArgs = {
  organizationId: Scalars['ID']['input'];
  role: OrganizationRoles;
  userId: Scalars['ID']['input'];
};


export type MutationUpdatePostArgs = {
  input: UpdatePostInput;
  postId: Scalars['ID']['input'];
};


export type MutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


export type MutationUpdateSourceArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateSourceRouteArgs = {
  delayMs?: InputMaybe<Scalars['Int']['input']>;
  enrichments?: InputMaybe<Array<SourceRouteEnrichmentInput>>;
  enterprise?: InputMaybe<Scalars['Boolean']['input']>;
  routeId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
  wsMarkdownTemplate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateStreamArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStreamInput;
};


export type MutationUpdateStreamDeckArgs = {
  input: UpdateStreamDeckInput;
};


export type MutationUpdateStreamDeckSortOrderArgs = {
  sortOrder: Array<Scalars['String']['input']>;
};


export type MutationUpdateStreamPackageArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStreamPackageInput;
};


export type MutationUpdateTerminalSettingsArgs = {
  input: UpdateTerminalSettingsInput;
};


export type MutationUpdateTerminalTabArgs = {
  input: UpdateTerminalTabInput;
};


export type MutationUpdateTerminalTabSortOrderArgs = {
  sortOrder: Array<Scalars['String']['input']>;
};


export type MutationUpdateTournamentArgs = {
  id: Scalars['ID']['input'];
  input: TournamentInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpsertEnrichmentServiceArgs = {
  input: UpsertEnrichmentServiceInput;
};


export type MutationVoxSubscriptionCheckoutArgs = {
  priceId: Scalars['String']['input'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Notification = Node & {
  __typename?: 'Notification';
  createdAt: Scalars['String']['output'];
  eventSource: NotificationEventSource;
  id: Scalars['ID']['output'];
  inAppNotificationContent?: Maybe<InAppNotificationContent>;
  notificationUserId: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
  type: Array<NotificationType>;
};

export const NotificationEventSource = {
  Mention: 'MENTION',
  NewFollower: 'NEW_FOLLOWER',
  SubscribedAuthorPost: 'SUBSCRIBED_AUTHOR_POST',
  System: 'SYSTEM'
} as const;

export type NotificationEventSource = typeof NotificationEventSource[keyof typeof NotificationEventSource];
export type NotificationImage = {
  __typename?: 'NotificationImage';
  alt: Scalars['String']['output'];
  file?: Maybe<S3Object>;
  href?: Maybe<Scalars['String']['output']>;
};

export const NotificationType = {
  Email: 'EMAIL',
  InApp: 'IN_APP',
  Push: 'PUSH'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];
export type NotificationsPage = {
  __typename?: 'NotificationsPage';
  items: Array<Notification>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type NotificationsSettings = {
  __typename?: 'NotificationsSettings';
  EMAIL: Scalars['Boolean']['output'];
  IN_APP: Scalars['Boolean']['output'];
  mentions: Array<NotificationType>;
  newFollowers: Array<NotificationType>;
  subscribedAuthorPost: Array<NotificationType>;
  system: Array<NotificationType>;
};

export type NotificationsSettingsInput = {
  mentions: Array<NotificationType>;
  newFollowers: Array<NotificationType>;
  subscribedAuthorPost: Array<NotificationType>;
  system: Array<NotificationType>;
};

export type OAuthCode = {
  __typename?: 'OAuthCode';
  code: Scalars['String']['output'];
};

export type OAuthTokens = {
  __typename?: 'OAuthTokens';
  accessToken: Scalars['String']['output'];
  createdAt: Scalars['Float']['output'];
  idToken: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export const OnboardingLinkPage = {
  CustomStreams: 'CUSTOM_STREAMS',
  SettingsPayments: 'SETTINGS_PAYMENTS',
  Streams: 'STREAMS',
  StreamPackages: 'STREAM_PACKAGES'
} as const;

export type OnboardingLinkPage = typeof OnboardingLinkPage[keyof typeof OnboardingLinkPage];
export const OnboardingType = {
  DataStreams: 'DataStreams',
  FollowAuthors: 'FollowAuthors',
  Reputation: 'Reputation',
  Synoptic: 'Synoptic',
  Tournaments: 'Tournaments',
  UserInterests: 'UserInterests'
} as const;

export type OnboardingType = typeof OnboardingType[keyof typeof OnboardingType];
export type OpenAiKey = {
  __typename?: 'OpenAIKey';
  availableModels: Array<Scalars['String']['output']>;
  baseUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

export type OpticFeedsTwttrMutation = {
  __typename?: 'OpticFeedsTwttrMutation';
  checkout: TwttrApiCheckout;
};


export type OpticFeedsTwttrMutationCheckoutArgs = {
  prices?: InputMaybe<Array<TwttrApiCheckoutPriceInput>>;
};

export type OpticFeedsTwttrQuery = {
  __typename?: 'OpticFeedsTwttrQuery';
  billingPortalSession: TwttrApiBillingPortalSession;
  prices: Array<TwttrApiPrice>;
  subscriptions: Array<TwttrApiSubscription>;
};

export const Order = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type Order = typeof Order[keyof typeof Order];
export type OrganizationInput = {
  maxSeats?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationObject = {
  __typename?: 'OrganizationObject';
  id: Scalars['ID']['output'];
  maxSeats?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
};

export const OrganizationRoles = {
  Admin: 'ADMIN',
  Member: 'MEMBER'
} as const;

export type OrganizationRoles = typeof OrganizationRoles[keyof typeof OrganizationRoles];
export type OrganizationsPage = {
  __typename?: 'OrganizationsPage';
  items: Array<OrganizationObject>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaidDataInput = {
  prices: StripePriceInput;
};

export const PolymatcherActionType = {
  Dislike: 'dislike',
  Like: 'like',
  ManualAdd: 'manualAdd',
  Trade: 'trade'
} as const;

export type PolymatcherActionType = typeof PolymatcherActionType[keyof typeof PolymatcherActionType];
export type PolymatcherCandidate = {
  __typename?: 'PolymatcherCandidate';
  at: Scalars['String']['output'];
  inferenceFired: PolymatcherFiredState;
  inferenceId: Scalars['ID']['output'];
  latencyMs?: Maybe<Scalars['Float']['output']>;
  pipelineFired: Scalars['Boolean']['output'];
  postId?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  tau?: Maybe<Scalars['Float']['output']>;
  textLength: Scalars['Int']['output'];
  textPreview: Scalars['String']['output'];
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId: Scalars['ID']['output'];
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherCandidatePage = {
  __typename?: 'PolymatcherCandidatePage';
  items: Array<PolymatcherCandidate>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherCandidateSearchInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  inferenceFired?: InputMaybe<Scalars['Boolean']['input']>;
  marketText?: InputMaybe<Scalars['String']['input']>;
  newsText?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
  pipelineFired?: InputMaybe<Scalars['Boolean']['input']>;
  previewLength: Scalars['Int']['input'];
  sort: PolymatcherCandidateSort;
  unitText?: InputMaybe<Scalars['String']['input']>;
  window?: InputMaybe<PolymatcherTimeWindowInput>;
};

export const PolymatcherCandidateSort = {
  DateScore: 'dateScore',
  ScoreAsc: 'scoreAsc',
  ScoreDesc: 'scoreDesc',
  Threshold: 'threshold'
} as const;

export type PolymatcherCandidateSort = typeof PolymatcherCandidateSort[keyof typeof PolymatcherCandidateSort];
export type PolymatcherExplainAnswerMarket = {
  __typename?: 'PolymatcherExplainAnswerMarket';
  conditionId: Scalars['ID']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  eventTitle?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherExplainCandidate = {
  __typename?: 'PolymatcherExplainCandidate';
  ce: Scalars['Float']['output'];
  clearedTau: Scalars['Boolean']['output'];
  docText: Scalars['String']['output'];
  inAnswer: Scalars['Boolean']['output'];
  marketCount: Scalars['Int']['output'];
  ms: Scalars['Float']['output'];
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  unitId: Scalars['ID']['output'];
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherExplainInput = {
  newsText: Scalars['String']['input'];
};

export type PolymatcherExplainResult = {
  __typename?: 'PolymatcherExplainResult';
  detail?: Maybe<Scalars['String']['output']>;
  run?: Maybe<PolymatcherExplainRun>;
  status: PolymatcherExplainStatus;
};

export type PolymatcherExplainRun = {
  __typename?: 'PolymatcherExplainRun';
  answer: Array<PolymatcherExplainAnswerMarket>;
  candidates: Array<PolymatcherExplainCandidate>;
  capped: Scalars['Boolean']['output'];
  corpusRows: Scalars['Int']['output'];
  corpusVersion: Scalars['String']['output'];
  fired: Scalars['Boolean']['output'];
  latencyMs: Scalars['Float']['output'];
  maxMarkets: Scalars['Int']['output'];
  ranAt: Scalars['String']['output'];
  recallTarget: Scalars['String']['output'];
  retrieverVersion: Scalars['String']['output'];
  roundTripMs: Scalars['Float']['output'];
  scoredChars: Scalars['Int']['output'];
  tau: Scalars['Float']['output'];
  truncated: Scalars['Boolean']['output'];
};

export const PolymatcherExplainStatus = {
  BackendError: 'backendError',
  NotDeployed: 'notDeployed',
  NotRunning: 'notRunning',
  Ok: 'ok',
  Starting: 'starting',
  TimedOut: 'timedOut',
  Unauthorized: 'unauthorized',
  Unreachable: 'unreachable'
} as const;

export type PolymatcherExplainStatus = typeof PolymatcherExplainStatus[keyof typeof PolymatcherExplainStatus];
export const PolymatcherFiredState = {
  Fired: 'fired',
  NotFired: 'notFired',
  Unknown: 'unknown'
} as const;

export type PolymatcherFiredState = typeof PolymatcherFiredState[keyof typeof PolymatcherFiredState];
export type PolymatcherLabelAuthor = {
  __typename?: 'PolymatcherLabelAuthor';
  authorEmail: Scalars['String']['output'];
  authorSub: Scalars['ID']['output'];
};

export type PolymatcherLabelExport = {
  __typename?: 'PolymatcherLabelExport';
  at?: Maybe<Scalars['String']['output']>;
  authorEmail: Scalars['String']['output'];
  conditionId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  inferenceId?: Maybe<Scalars['ID']['output']>;
  marketText?: Maybe<Scalars['String']['output']>;
  newsText: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  pairKey: Scalars['String']['output'];
  postId?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  source: PolymatcherPairSource;
  tau?: Maybe<Scalars['Float']['output']>;
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['ID']['output']>;
  unitQuestion?: Maybe<Scalars['String']['output']>;
  value: PolymatcherLabelValue;
};

export type PolymatcherLabelExportInput = {
  batchSize: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
};

export type PolymatcherLabelExportPage = {
  __typename?: 'PolymatcherLabelExportPage';
  items: Array<PolymatcherLabelExport>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherLabelReviewInput = {
  batchSize: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  otherAuthorSub?: InputMaybe<Scalars['ID']['input']>;
};

export const PolymatcherLabelValue = {
  Match: 'match',
  NoMatch: 'noMatch',
  Unsure: 'unsure'
} as const;

export type PolymatcherLabelValue = typeof PolymatcherLabelValue[keyof typeof PolymatcherLabelValue];
export type PolymatcherLabellingCandidate = {
  __typename?: 'PolymatcherLabellingCandidate';
  at: Scalars['String']['output'];
  inferenceFired: PolymatcherFiredState;
  inferenceId: Scalars['ID']['output'];
  newsText: Scalars['String']['output'];
  pipelineFired: Scalars['Boolean']['output'];
  postId?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  tau?: Maybe<Scalars['Float']['output']>;
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId: Scalars['ID']['output'];
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherLabellingCandidatePage = {
  __typename?: 'PolymatcherLabellingCandidatePage';
  items: Array<PolymatcherLabellingCandidate>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherLabellingQueueInput = {
  batchSize: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  inferenceFired?: InputMaybe<Scalars['Boolean']['input']>;
  pipelineFired?: InputMaybe<Scalars['Boolean']['input']>;
  sort: PolymatcherCandidateSort;
  /** @deprecated The source selects the query, not a field on this input */
  source?: InputMaybe<PolymatcherPairSource>;
  window?: InputMaybe<PolymatcherTimeWindowInput>;
};

export type PolymatcherManualPair = {
  __typename?: 'PolymatcherManualPair';
  ambiguousUnit: Scalars['Boolean']['output'];
  at: Scalars['String']['output'];
  conditionId: Scalars['ID']['output'];
  inferenceId?: Maybe<Scalars['ID']['output']>;
  marketQuestion: Scalars['String']['output'];
  newsText: Scalars['String']['output'];
  pipelineFired?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  tau?: Maybe<Scalars['Float']['output']>;
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId: Scalars['ID']['output'];
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherManualPairInput = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
  conditionId: Scalars['ID']['input'];
  inferenceId?: InputMaybe<Scalars['ID']['input']>;
  newsText?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['ID']['input']>;
};

export type PolymatcherMarket = {
  __typename?: 'PolymatcherMarket';
  conditionId: Scalars['ID']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  eventTitle?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  volume: Scalars['Float']['output'];
};

export type PolymatcherMarketSearchInput = {
  excludeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  limit: Scalars['Int']['input'];
  recentlyClosed: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export const PolymatcherMissKind = {
  Ranking: 'ranking',
  Retrieval: 'retrieval'
} as const;

export type PolymatcherMissKind = typeof PolymatcherMissKind[keyof typeof PolymatcherMissKind];
export type PolymatcherNewsItem = {
  __typename?: 'PolymatcherNewsItem';
  at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: PolymatcherNewsSource;
  text: Scalars['String']['output'];
};

export type PolymatcherNewsSearchInput = {
  limit: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export const PolymatcherNewsSource = {
  Inference: 'inference',
  StreamPost: 'streamPost'
} as const;

export type PolymatcherNewsSource = typeof PolymatcherNewsSource[keyof typeof PolymatcherNewsSource];
export const PolymatcherPairSource = {
  Import: 'import',
  Inference: 'inference',
  Manual: 'manual',
  UserAction: 'userAction'
} as const;

export type PolymatcherPairSource = typeof PolymatcherPairSource[keyof typeof PolymatcherPairSource];
export type PolymatcherReviewLabel = {
  __typename?: 'PolymatcherReviewLabel';
  authorEmail: Scalars['String']['output'];
  authorSub: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  value: PolymatcherLabelValue;
};

export type PolymatcherReviewPair = {
  __typename?: 'PolymatcherReviewPair';
  at?: Maybe<Scalars['String']['output']>;
  conditionId?: Maybe<Scalars['ID']['output']>;
  inferenceId?: Maybe<Scalars['ID']['output']>;
  labels: Array<PolymatcherReviewLabel>;
  marketText?: Maybe<Scalars['String']['output']>;
  newsText: Scalars['String']['output'];
  pairId: Scalars['ID']['output'];
  postId?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  source: PolymatcherPairSource;
  tau?: Maybe<Scalars['Float']['output']>;
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['ID']['output']>;
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherReviewPairPage = {
  __typename?: 'PolymatcherReviewPairPage';
  items: Array<PolymatcherReviewPair>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherSetLabelInput = {
  conditionId?: InputMaybe<Scalars['ID']['input']>;
  inferenceId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  rank: Scalars['Int']['input'];
  value: PolymatcherLabelValue;
};

export type PolymatcherSetLabelResult = {
  __typename?: 'PolymatcherSetLabelResult';
  labelId: Scalars['ID']['output'];
  pairId: Scalars['ID']['output'];
};

export type PolymatcherSetManualLabelInput = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
  conditionId: Scalars['ID']['input'];
  inferenceId?: InputMaybe<Scalars['ID']['input']>;
  newsText?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['ID']['input']>;
  value: PolymatcherLabelValue;
};

export type PolymatcherSetUserActionLabelInput = {
  conditionId: Scalars['ID']['input'];
  /** @deprecated The pair is keyed on the source post */
  inferenceId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  sourcePostId?: InputMaybe<Scalars['ID']['input']>;
  unitId: Scalars['ID']['input'];
  value: PolymatcherLabelValue;
};

export type PolymatcherTimeWindowInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type PolymatcherUnitMarket = {
  __typename?: 'PolymatcherUnitMarket';
  conditionId: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type PolymatcherUserActionCandidate = {
  __typename?: 'PolymatcherUserActionCandidate';
  at?: Maybe<Scalars['String']['output']>;
  conditionId: Scalars['ID']['output'];
  dislikes: Scalars['Int']['output'];
  inferenceId?: Maybe<Scalars['ID']['output']>;
  lastActionAt: Scalars['String']['output'];
  likes: Scalars['Int']['output'];
  manualAdds: Scalars['Int']['output'];
  marketText: Scalars['String']['output'];
  miss?: Maybe<PolymatcherMissKind>;
  newsText: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  sourcePostId: Scalars['ID']['output'];
  tau?: Maybe<Scalars['Float']['output']>;
  trades: Scalars['Int']['output'];
  unitDocText?: Maybe<Scalars['String']['output']>;
  unitId: Scalars['ID']['output'];
  unitQuestion?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherUserActionCandidatePage = {
  __typename?: 'PolymatcherUserActionCandidatePage';
  items: Array<PolymatcherUserActionCandidate>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PolymatcherUserActionQueueInput = {
  actionType?: InputMaybe<PolymatcherActionType>;
  batchSize: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  window?: InputMaybe<PolymatcherTimeWindowInput>;
};

export type PolymatcherUserActionRefreshReport = {
  __typename?: 'PolymatcherUserActionRefreshReport';
  ambiguousUnitInterval: Scalars['Int']['output'];
  kept: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
  seen: Scalars['Int']['output'];
  unmappable: Scalars['Int']['output'];
  unresolved: Scalars['Int']['output'];
  unresolvedByCause: PolymatcherUserActionUnresolvedCauses;
  viaCatalog: Scalars['Int']['output'];
  written: Scalars['Int']['output'];
};

export type PolymatcherUserActionUnresolvedCauses = {
  __typename?: 'PolymatcherUserActionUnresolvedCauses';
  marketNotInCatalog: Scalars['Int']['output'];
  /** @deprecated A missing inference now resolves from the catalog */
  noInference: Scalars['Int']['output'];
  noPostText: Scalars['Int']['output'];
  noSourcePostId: Scalars['Int']['output'];
  postMissing: Scalars['Int']['output'];
  sourcePostMissing: Scalars['Int']['output'];
  unknownPostType: Scalars['Int']['output'];
};

export type PostMarketAddMarketSignal = {
  __typename?: 'PostMarketAddMarketSignal';
  createdAt: Scalars['String']['output'];
  marketId: Scalars['ID']['output'];
  platform: PostMarketSignalPlatform;
  postId: Scalars['ID']['output'];
  source: PostMarketSignalSource;
  sourcePostId?: Maybe<Scalars['ID']['output']>;
  streamId: Scalars['ID']['output'];
  trigger: PostMarketSignalTrigger;
  userId: Scalars['ID']['output'];
};

export type PostMarketAddMarketSignalInput = {
  marketId: Scalars['ID']['input'];
  platform: PostMarketSignalPlatform;
  postId: Scalars['ID']['input'];
  sourcePostId?: InputMaybe<Scalars['ID']['input']>;
  streamId: Scalars['ID']['input'];
  trigger: PostMarketSignalTrigger;
};

export type PostMarketButtonSignalInput = {
  action: PostMarketSignalAction;
  marketId: Scalars['ID']['input'];
  platform: PostMarketSignalPlatform;
  postId: Scalars['ID']['input'];
  sourcePostId?: InputMaybe<Scalars['ID']['input']>;
  streamId: Scalars['ID']['input'];
};

export type PostMarketSignal = {
  __typename?: 'PostMarketSignal';
  action: PostMarketSignalAction;
  createdAt: Scalars['String']['output'];
  marketId: Scalars['ID']['output'];
  platform: PostMarketSignalPlatform;
  postId: Scalars['ID']['output'];
  source: PostMarketSignalSource;
  sourcePostId?: Maybe<Scalars['ID']['output']>;
  streamId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export const PostMarketSignalAction = {
  Dislike: 'DISLIKE',
  Like: 'LIKE'
} as const;

export type PostMarketSignalAction = typeof PostMarketSignalAction[keyof typeof PostMarketSignalAction];
export const PostMarketSignalPlatform = {
  Binance: 'BINANCE',
  Bybit: 'BYBIT',
  Hyperliquid: 'HYPERLIQUID',
  Kalshi: 'KALSHI',
  Polymarket: 'POLYMARKET'
} as const;

export type PostMarketSignalPlatform = typeof PostMarketSignalPlatform[keyof typeof PostMarketSignalPlatform];
export const PostMarketSignalSource = {
  AddMarket: 'ADD_MARKET',
  Button: 'BUTTON',
  Trade: 'TRADE'
} as const;

export type PostMarketSignalSource = typeof PostMarketSignalSource[keyof typeof PostMarketSignalSource];
export const PostMarketSignalTrigger = {
  Group: 'GROUP',
  Post: 'POST'
} as const;

export type PostMarketSignalTrigger = typeof PostMarketSignalTrigger[keyof typeof PostMarketSignalTrigger];
export type PostMatchFilterInput = {
  crypto?: InputMaybe<Scalars['Boolean']['input']>;
  cryptoKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  kalshi?: InputMaybe<Scalars['Boolean']['input']>;
  polymarket?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostsPage = {
  __typename?: 'PostsPage';
  items: Array<PostsPageItem>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PostsPageItem = RePost | RegularPost | StreamPost | TournamentPost;

export type ProtectedStreamFields = {
  __typename?: 'ProtectedStreamFields';
  streamApiKeys: Array<StreamApiKey>;
};

export type ProtectedUserFields = {
  __typename?: 'ProtectedUserFields';
  apiKeys?: Maybe<Array<StreamApiKey>>;
  coupons?: Maybe<Array<UserCoupon>>;
  email: Scalars['String']['output'];
  intercomHmac: Scalars['String']['output'];
  isOnboardingFinished: Scalars['Boolean']['output'];
  onboardingProgress?: Maybe<Array<OnboardingType>>;
  openAIKey?: Maybe<OpenAiKey>;
  possibleUsernames?: Maybe<Array<Scalars['String']['output']>>;
  pushNotificationSubscriptions?: Maybe<Array<PushNotificationSubscription>>;
  stripeExpressSellerAccount?: Maybe<StripeSellerAccount>;
  twttrApiAccount: TwttrApiAccount;
  voxSubscription: VoxSubscription;
};

export type PushNotificationSubscription = {
  __typename?: 'PushNotificationSubscription';
  endpoint: Scalars['String']['output'];
  keys: KeysType;
};

export type PushNotificationSubscriptionInput = {
  endpoint: Scalars['String']['input'];
  expirationTime?: InputMaybe<Scalars['String']['input']>;
  keys?: InputMaybe<KeysInput>;
};

export type Query = {
  __typename?: 'Query';
  OpticFeedsTwttrQuery: OpticFeedsTwttrQuery;
  /** Full enrichment service registry (admin). */
  adminEnrichmentServices: Array<EnrichmentService>;
  /** Evaluate an AI filter */
  aiFilterEvaluation: AiFilterEvaluation;
  aiFilterTest: Scalars['Boolean']['output'];
  aiFilters: Array<AiFilter>;
  allStreamsPostsSearch: StreamPostsPage;
  closedTournaments: TournamentsPage;
  customCollectionPosts: CustomCollectionPostsPage;
  customCollections: Array<CustomCollection>;
  discussionFeed: DiscussionPage;
  discussionPost: DiscussionPost;
  enrichmentInvocations: EnrichmentInvocationPage;
  enrichmentLatencyBuckets: Array<EnrichmentLatencyBucket>;
  /** Enabled enrichment service names for the route editor picker. Does not expose urls or secrets. */
  enrichmentServices: Array<EnrichmentServiceName>;
  enterpriseStreamPosts: EnterpriseStreamPostsPage;
  exportEnterpriseStreamPostsUrl: Scalars['String']['output'];
  exportStreamPostsUrl: Scalars['String']['output'];
  flags: Array<Flag>;
  followersByName: UsersPage;
  followingByName: UsersPage;
  getCustomerBillingPortalSession: StripeBillingPortalSession;
  getStreamFollowExpiration?: Maybe<Scalars['String']['output']>;
  getUserStreamPackagesSubscribed: Array<StreamPackage>;
  getUserStreamsFollowed: Array<Stream>;
  getUserStreamsSubscribed: Array<Stream>;
  getUsers: UsersPage;
  highlightedAuthors: Array<User>;
  learningProgress: LearningProgress;
  me: User;
  medal?: Maybe<Medal>;
  medals: MedalsPage;
  mySourceTags: Array<Scalars['String']['output']>;
  mySources: SourceSearchResult;
  myVoxFullAccessRequest?: Maybe<VoxFullAccessRequest>;
  notifications: NotificationsPage;
  organization?: Maybe<OrganizationObject>;
  organizationUsers: UsersPage;
  organizations: OrganizationsPage;
  polymatcherCandidates: PolymatcherCandidatePage;
  polymatcherLabelAuthors: Array<PolymatcherLabelAuthor>;
  polymatcherLabelExport: PolymatcherLabelExportPage;
  polymatcherLabelReview: PolymatcherReviewPairPage;
  polymatcherLabellingQueue: PolymatcherLabellingCandidatePage;
  polymatcherManualPair?: Maybe<PolymatcherManualPair>;
  polymatcherMarketSearch: Array<PolymatcherMarket>;
  polymatcherNewsSearch: Array<PolymatcherNewsItem>;
  polymatcherUnitMarkets: Array<PolymatcherUnitMarket>;
  polymatcherUserActionQueue: PolymatcherUserActionCandidatePage;
  post?: Maybe<PostsPageItem>;
  publicStreamPostPreview: StreamPostsPage;
  publicTournaments: TournamentsPage;
  search: SearchResultPage;
  searchStreamPosts: StreamPostsPage;
  settings: UserSettings;
  source?: Maybe<Source>;
  sourcePostSearch: SourcePostSearchResult;
  stream?: Maybe<Stream>;
  streamDecks: Array<StreamDeck>;
  streamInvites: StreamInvitesPage;
  streamPackage?: Maybe<StreamPackage>;
  streamPackages: StreamPackagesPage;
  streamPosts: StreamPostsPage;
  streamPostsStats: StreamPostsStatsResult;
  streamRoutes: Array<SourceRoute>;
  streamUsers: Array<User>;
  streamsAll: StreamsPage;
  streamsCreated: StreamsPage;
  streamsFollowing: StreamsPage;
  streamsStats: StreamsStatsResult;
  summarizeStreamPost: Scalars['String']['output'];
  terminalSettings: TerminalSettings;
  terminalTabs: Array<TerminalTab>;
  tournament?: Maybe<Tournament>;
  tournamentWinners: Array<TournamentWinner>;
  tournaments: TournamentsPage;
  typeahead: TypeaheadResult;
  user: User;
  userById: User;
  userStreamInvites: StreamInvitesPage;
  userStreamPackages: StreamPackagesPage;
  userStreams: StreamsPage;
  voxConfig: VoxConfig;
  voxFullAccessRequests: VoxFullAccessRequestsPage;
  voxHistory: VoxHistoryPage;
  voxTextSearch: VoxTextSearchResult;
  voxUserNamesSearch: VoxUserNamesSearchResult;
  voxUserSearch: VoxUserProfileResult;
};


export type QueryAiFilterEvaluationArgs = {
  filter: AiFilterTestInput;
};


export type QueryAiFilterTestArgs = {
  filter: AiFilterTestInput;
  text: Scalars['String']['input'];
};


export type QueryAllStreamsPostsSearchArgs = {
  input: AllStreamsPostsSearchInput;
};


export type QueryClosedTournamentsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomCollectionPostsArgs = {
  collectionId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  matchFilter?: InputMaybe<PostMatchFilterInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  streamDeckId: Scalars['ID']['input'];
};


export type QueryCustomCollectionsArgs = {
  streamDeckId: Scalars['ID']['input'];
};


export type QueryDiscussionFeedArgs = {
  discussionContextId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: Order;
};


export type QueryDiscussionPostArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEnrichmentInvocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<EnrichmentInvocationOutcome>;
  service?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnrichmentLatencyBucketsArgs = {
  from: Scalars['String']['input'];
  service?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};


export type QueryEnterpriseStreamPostsArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  leafAz?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExportEnterpriseStreamPostsUrlArgs = {
  input: ExportEnterpriseStreamPostsInput;
};


export type QueryExportStreamPostsUrlArgs = {
  input: ExportStreamPostsInput;
};


export type QueryFollowersByNameArgs = {
  isInfluential?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type QueryFollowingByNameArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type QueryGetStreamFollowExpirationArgs = {
  input: StreamFollowExpirationInput;
};


export type QueryGetUserStreamPackagesSubscribedArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserStreamsFollowedArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserStreamsSubscribedArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUsersArgs = {
  input: UsersListInput;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMedalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMedalsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMySourcesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationUsersArgs = {
  id: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPolymatcherCandidatesArgs = {
  input: PolymatcherCandidateSearchInput;
};


export type QueryPolymatcherLabelExportArgs = {
  input: PolymatcherLabelExportInput;
};


export type QueryPolymatcherLabelReviewArgs = {
  input: PolymatcherLabelReviewInput;
};


export type QueryPolymatcherLabellingQueueArgs = {
  input: PolymatcherLabellingQueueInput;
};


export type QueryPolymatcherManualPairArgs = {
  input: PolymatcherManualPairInput;
};


export type QueryPolymatcherMarketSearchArgs = {
  input: PolymatcherMarketSearchInput;
};


export type QueryPolymatcherNewsSearchArgs = {
  input: PolymatcherNewsSearchInput;
};


export type QueryPolymatcherUnitMarketsArgs = {
  unitId: Scalars['ID']['input'];
};


export type QueryPolymatcherUserActionQueueArgs = {
  input: PolymatcherUserActionQueueInput;
};


export type QueryPostArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicStreamPostPreviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicTournamentsArgs = {
  closed?: Scalars['Boolean']['input'];
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchArgs = {
  input: SearchInput;
};


export type QuerySearchStreamPostsArgs = {
  input: SearchStreamPostsInput;
};


export type QuerySourceArgs = {
  sourceId: Scalars['ID']['input'];
};


export type QuerySourcePostSearchArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['ID']['input'];
  status?: InputMaybe<ValidationStatus>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStreamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStreamInvitesArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['ID']['input'];
};


export type QueryStreamPackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStreamPackagesArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  queryType?: StreamPackageQueryType;
  streamPackageCategory?: InputMaybe<StreamCategory>;
};


export type QueryStreamPostsArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  matchFilter?: InputMaybe<PostMatchFilterInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryStreamPostsStatsArgs = {
  input: StreamPostsStatsInput;
};


export type QueryStreamRoutesArgs = {
  streamId: Scalars['ID']['input'];
};


export type QueryStreamUsersArgs = {
  streamId: Scalars['ID']['input'];
  type: StreamUserFilterType;
};


export type QueryStreamsAllArgs = {
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  minFollowers?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  pricingType?: InputMaybe<StreamPricingType>;
  sortBy?: InputMaybe<StreamSortBy>;
  streamCategory?: InputMaybe<StreamCategory>;
  streamState?: InputMaybe<StreamState>;
};


export type QueryStreamsCreatedArgs = {
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  pricingType?: InputMaybe<StreamPricingType>;
  sortBy?: InputMaybe<StreamSortBy>;
  streamCategory?: InputMaybe<StreamCategory>;
  streamState?: InputMaybe<StreamState>;
  streamType?: InputMaybe<StreamType>;
};


export type QueryStreamsFollowingArgs = {
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  pricingType?: InputMaybe<StreamPricingType>;
  sortBy?: InputMaybe<StreamSortBy>;
  streamCategory?: InputMaybe<StreamCategory>;
  streamState?: InputMaybe<StreamState>;
  streamType?: InputMaybe<StreamType>;
};


export type QueryStreamsStatsArgs = {
  input: StreamsStatsInput;
};


export type QuerySummarizeStreamPostArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryTournamentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTournamentsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortBy?: TournamentSortOption;
  state?: InputMaybe<TournamentState>;
};


export type QueryTypeaheadArgs = {
  input: TypeaheadInput;
};


export type QueryUserArgs = {
  username: Scalars['String']['input'];
};


export type QueryUserByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserStreamInvitesArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserStreamPackagesArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type QueryUserStreamsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type QueryVoxFullAccessRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VoxAccessRequestStatus>;
};


export type QueryVoxHistoryArgs = {
  input: VoxHistoryInput;
};


export type QueryVoxTextSearchArgs = {
  input: VoxTextSearchInput;
};


export type QueryVoxUserNamesSearchArgs = {
  input: VoxUserSearchInput;
};


export type QueryVoxUserSearchArgs = {
  input: VoxUserSearchInput;
};

export type RePost = Node & {
  __typename?: 'RePost';
  author: User;
  authorId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  originalPost: RegularPost;
};

export type RePostInput = {
  originalPostId: Scalars['ID']['input'];
};

export type RedeemPointsResult = {
  __typename?: 'RedeemPointsResult';
  redeemedPoints: Scalars['Int']['output'];
  remainingPoints: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type RegularPost = IPost & Node & {
  __typename?: 'RegularPost';
  author: User;
  authorId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  json?: Maybe<Scalars['String']['output']>;
  markdown?: Maybe<Scalars['String']['output']>;
  matchAiFilter?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Array<S3Object>>;
  quotedPost?: Maybe<PostsPageItem>;
  repostId?: Maybe<Scalars['ID']['output']>;
  reputationBet: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type RegularPostInput = {
  json?: InputMaybe<Scalars['LexicalJSON']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<S3ObjectInput>>;
  quotePostId?: InputMaybe<Scalars['ID']['input']>;
  reputationBet?: Scalars['Float']['input'];
  text: Scalars['String']['input'];
};

export type S3Object = {
  __typename?: 'S3Object';
  bucket: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the S3 upload is pending */
  isS3UploadPending?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  region: Scalars['String']['output'];
  /** file mime type */
  type: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type S3ObjectInput = {
  bucket: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates if the S3 upload is pending */
  isS3UploadPending?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  region: Scalars['String']['input'];
  /** file mime type */
  type: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type SchemaHistoryEntry = {
  __typename?: 'SchemaHistoryEntry';
  schema: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export const ScoreHistoryResolution = {
  Day: 'DAY',
  Hour: 'HOUR',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Year: 'YEAR'
} as const;

export type ScoreHistoryResolution = typeof ScoreHistoryResolution[keyof typeof ScoreHistoryResolution];
export type SearchFilters = {
  stream?: InputMaybe<StreamSearchFilters>;
  tournament?: InputMaybe<TournamentSearchFilters>;
  type?: InputMaybe<Array<SearchType>>;
};

export type SearchInput = {
  filters?: InputMaybe<SearchFilters>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  type?: InputMaybe<Array<SearchType>>;
};

export type SearchResultPage = IOffsetPage & {
  __typename?: 'SearchResultPage';
  items: Array<Node>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type SearchStreamPostsInput = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  streamId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export const SearchType = {
  RegularPost: 'RegularPost',
  Stream: 'Stream',
  StreamPackage: 'StreamPackage',
  Tournament: 'Tournament',
  User: 'User'
} as const;

export type SearchType = typeof SearchType[keyof typeof SearchType];
export type SetStreamCustomTargetsInput = {
  customTargets: Array<Scalars['String']['input']>;
};

export type SetStreamFollowExpirationInput = {
  expiresAt: Scalars['String']['input'];
  streamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type Source = {
  __typename?: 'Source';
  name: Scalars['String']['output'];
  routes: Array<SourceRoute>;
  schema: Scalars['String']['output'];
  schemaHistory?: Maybe<Array<SchemaHistoryEntry>>;
  schemaVersion: Scalars['Int']['output'];
  sourceId: Scalars['ID']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type SourcePost = {
  __typename?: 'SourcePost';
  createdAt: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Int']['output'];
  sourceId: Scalars['String']['output'];
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
  validationStatus: ValidationStatus;
};

export type SourcePostSearchResult = {
  __typename?: 'SourcePostSearchResult';
  items: Array<SourcePost>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type SourceRoute = {
  __typename?: 'SourceRoute';
  createdAt: Scalars['String']['output'];
  delayMs?: Maybe<Scalars['Int']['output']>;
  /** Enricher bindings applied on this route before fan-out. */
  enrichments?: Maybe<Array<SourceRouteEnrichment>>;
  /** Whether posts on this route are published to the enterprise API. */
  enterprise: Scalars['Boolean']['output'];
  routeId: Scalars['ID']['output'];
  source?: Maybe<Source>;
  sourceId: Scalars['ID']['output'];
  stream?: Maybe<Stream>;
  streamId: Scalars['ID']['output'];
  /** Markdown template applied to posts forwarded to the ws-api on this route. */
  wsMarkdownTemplate?: Maybe<Scalars['String']['output']>;
};

export type SourceRouteEnrichment = {
  __typename?: 'SourceRouteEnrichment';
  /** JSON value used when the enricher fails. String leaves are template-rendered against source data plus {{input}}. */
  errorFallback?: Maybe<Scalars['String']['output']>;
  inputTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type SourceRouteEnrichmentInput = {
  /** JSON value used when the enricher fails. String leaves are template-rendered against source data plus {{input}}. */
  errorFallback?: InputMaybe<Scalars['String']['input']>;
  inputTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type SourceSearchResult = {
  __typename?: 'SourceSearchResult';
  items: Array<Source>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export const StatsInterval = {
  Day: 'DAY',
  Hour: 'HOUR',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK'
} as const;

export type StatsInterval = typeof StatsInterval[keyof typeof StatsInterval];
export type Stream = Node & {
  __typename?: 'Stream';
  accessAllowed: Scalars['Boolean']['output'];
  apiAccessEnabled: Scalars['Boolean']['output'];
  author: User;
  canAddToStreamDeck: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  customTargets?: Maybe<Array<Scalars['String']['output']>>;
  customTargetsData?: Maybe<CustomTargetsData>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionJson: Scalars['LexicalJSON']['output'];
  followersCount: Scalars['Int']['output'];
  following: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<S3Object>;
  inPackages: Array<StreamPackage>;
  isEmpty: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  packageOnly: Scalars['Boolean']['output'];
  paidData?: Maybe<Array<StripePrice>>;
  protectedFields?: Maybe<ProtectedStreamFields>;
  slug: Scalars['String']['output'];
  streamCategory: StreamCategory;
  streamState: StreamState;
  streamType: StreamType;
  subscription?: Maybe<StreamSubscription>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type StreamApiKey = Node & {
  __typename?: 'StreamApiKey';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  keyName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<ApiKeyPermissionsObject>;
  secretHint: Scalars['String']['output'];
};

export const StreamCategory = {
  Markets: 'MARKETS',
  News: 'NEWS',
  OnChain: 'ON_CHAIN',
  Osint: 'OSINT',
  Other: 'OTHER',
  Regulatory: 'REGULATORY'
} as const;

export type StreamCategory = typeof StreamCategory[keyof typeof StreamCategory];
export type StreamDeck = Node & {
  __typename?: 'StreamDeck';
  collections: Array<CustomCollection>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StreamFollowExpirationInput = {
  streamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type StreamInput = {
  apiAccessEnabled: Scalars['Boolean']['input'];
  customTargetsData?: InputMaybe<CustomTargetsDataInput>;
  /** @deprecated use descriptionJson instead */
  description?: InputMaybe<Scalars['LexicalJSON']['input']>;
  descriptionJson?: InputMaybe<Scalars['LexicalJSON']['input']>;
  image?: InputMaybe<S3ObjectInput>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  packageOnly?: Scalars['Boolean']['input'];
  paidData?: InputMaybe<PaidDataInput>;
  streamCategory?: StreamCategory;
  streamType?: StreamType;
};

export type StreamInvite = Node & {
  __typename?: 'StreamInvite';
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitee?: Maybe<User>;
  stream: Stream;
  streamInviteId: Scalars['ID']['output'];
};

export type StreamInvitesPage = {
  __typename?: 'StreamInvitesPage';
  items: Array<StreamInvite>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type StreamListFilters = {
  __typename?: 'StreamListFilters';
  /** Max matched markets to show per post (1-10) */
  maxMatchedMarkets: Scalars['Int']['output'];
  /** Hide markets missing a 0.1¢ orderbook level on either outcome side */
  requireOrderbookTails: Scalars['Boolean']['output'];
  /** Maximum market volume for stream list matched markets */
  volumeMax?: Maybe<Scalars['Float']['output']>;
  /** Minimum market volume for stream list matched markets */
  volumeMin?: Maybe<Scalars['Float']['output']>;
};

export type StreamListFiltersInput = {
  maxMatchedMarkets?: InputMaybe<Scalars['Int']['input']>;
  requireOrderbookTails?: InputMaybe<Scalars['Boolean']['input']>;
  volumeMax?: InputMaybe<Scalars['Float']['input']>;
  volumeMin?: InputMaybe<Scalars['Float']['input']>;
};

export type StreamPackage = Node & {
  __typename?: 'StreamPackage';
  author: User;
  badge: StreamPackageBadge;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionJson: Scalars['LexicalJSON']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<S3Object>;
  includedStreams: Array<Stream>;
  isFeaturedPackage: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paidData: Array<StripePrice>;
  streamPackageCategory: StreamCategory;
  subscribersCount: Scalars['Int']['output'];
  subscription?: Maybe<StreamPackageSubscription>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export const StreamPackageBadge = {
  ExclusiveContent: 'EXCLUSIVE_CONTENT',
  SaveValue: 'SAVE_VALUE'
} as const;

export type StreamPackageBadge = typeof StreamPackageBadge[keyof typeof StreamPackageBadge];
export type StreamPackageInput = {
  badge: StreamPackageBadge;
  /** @deprecated use descriptionJson instead */
  description?: InputMaybe<Scalars['LexicalJSON']['input']>;
  descriptionJson?: InputMaybe<Scalars['LexicalJSON']['input']>;
  image?: InputMaybe<S3ObjectInput>;
  includedStreamIds: Array<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paidData: PaidDataInput;
  streamPackageCategory: StreamCategory;
};

export const StreamPackageQueryType = {
  All: 'ALL',
  Created: 'CREATED',
  Featured: 'FEATURED',
  Subscribed: 'SUBSCRIBED'
} as const;

export type StreamPackageQueryType = typeof StreamPackageQueryType[keyof typeof StreamPackageQueryType];
export type StreamPackageSubscription = {
  __typename?: 'StreamPackageSubscription';
  active: Scalars['Boolean']['output'];
  cancelAt?: Maybe<Scalars['String']['output']>;
  interval: StripeBillingInterval;
  intervalCount: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
};

export type StreamPackageSubscriptionCancelInput = {
  cancelationComment: Scalars['String']['input'];
  cancelationReason: StreamSubscriptionCancelReason;
  refundComment?: InputMaybe<Scalars['String']['input']>;
  streamPackageId: Scalars['ID']['input'];
};

export type StreamPackagesPage = {
  __typename?: 'StreamPackagesPage';
  items: Array<StreamPackage>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type StreamPost = IPost & Node & {
  __typename?: 'StreamPost';
  author: User;
  authorId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  customTarget?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Structured enrichments attached by source-route enrichers. Omitted when empty. */
  enrichments?: Maybe<EnrichmentsObject>;
  id: Scalars['ID']['output'];
  matchAiFilter?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Array<S3Object>>;
  metadata?: Maybe<MetadataObject>;
  /** Source that produced this post via a source route. */
  sourceId?: Maybe<Scalars['ID']['output']>;
  /** Source post id used by enrichers. Distinct from this stream post id because one source post can fan out to multiple streams. */
  sourcePostId?: Maybe<Scalars['ID']['output']>;
  stream: Stream;
  summary?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  vendorMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type StreamPostCount = {
  __typename?: 'StreamPostCount';
  count: Scalars['Int']['output'];
  streamId: Scalars['ID']['output'];
};

export type StreamPostInput = {
  customTarget?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<S3ObjectInput>>;
  metadata?: InputMaybe<MetadataInput>;
  streamId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type StreamPostsPage = {
  __typename?: 'StreamPostsPage';
  items: Array<StreamPost>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type StreamPostsStatsInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  interval: StatsInterval;
  streamId: Scalars['ID']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type StreamPostsStatsResult = {
  __typename?: 'StreamPostsStatsResult';
  buckets: Array<TimeBucket>;
  total: Scalars['Int']['output'];
};

export const StreamPricingType = {
  All: 'ALL',
  Free: 'FREE',
  PackageOnly: 'PACKAGE_ONLY',
  Paid: 'PAID'
} as const;

export type StreamPricingType = typeof StreamPricingType[keyof typeof StreamPricingType];
export const StreamQueryType = {
  All: 'ALL',
  Created: 'CREATED',
  Following: 'FOLLOWING'
} as const;

export type StreamQueryType = typeof StreamQueryType[keyof typeof StreamQueryType];
export type StreamSearchFilters = {
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  streamCategory?: InputMaybe<StreamCategory>;
};

export const StreamSortBy = {
  CreatedAt: 'CREATED_AT',
  Followers: 'FOLLOWERS'
} as const;

export type StreamSortBy = typeof StreamSortBy[keyof typeof StreamSortBy];
export const StreamState = {
  Active: 'ACTIVE',
  Deleted: 'DELETED',
  Draft: 'DRAFT',
  Inactive: 'INACTIVE',
  OnHold: 'ON_HOLD'
} as const;

export type StreamState = typeof StreamState[keyof typeof StreamState];
export type StreamSubscription = {
  __typename?: 'StreamSubscription';
  active: Scalars['Boolean']['output'];
  cancelAt?: Maybe<Scalars['String']['output']>;
  customTargets?: Maybe<Scalars['Int']['output']>;
  interval: StripeBillingInterval;
  intervalCount: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
};

export type StreamSubscriptionCancelInput = {
  cancelationComment: Scalars['String']['input'];
  cancelationReason: StreamSubscriptionCancelReason;
  refundComment?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['ID']['input'];
};

export const StreamSubscriptionCancelReason = {
  DissatisfiedWithQuality: 'DISSATISFIED_WITH_QUALITY',
  FoundBetterAlternative: 'FOUND_BETTER_ALTERNATIVE',
  NoNeedAnymore: 'NO_NEED_ANYMORE',
  Other: 'OTHER',
  RemovedByAuthor: 'REMOVED_BY_AUTHOR',
  TooExpensive: 'TOO_EXPENSIVE'
} as const;

export type StreamSubscriptionCancelReason = typeof StreamSubscriptionCancelReason[keyof typeof StreamSubscriptionCancelReason];
export const StreamType = {
  Private: 'PRIVATE',
  Public: 'PUBLIC'
} as const;

export type StreamType = typeof StreamType[keyof typeof StreamType];
export const StreamUserFilterType = {
  Followers: 'FOLLOWERS',
  Subscribers: 'SUBSCRIBERS'
} as const;

export type StreamUserFilterType = typeof StreamUserFilterType[keyof typeof StreamUserFilterType];
export type StreamsPage = {
  __typename?: 'StreamsPage';
  items: Array<Stream>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type StreamsStatsInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  interval: StatsInterval;
  toDate?: InputMaybe<Scalars['String']['input']>;
  topN?: InputMaybe<Scalars['Int']['input']>;
};

export type StreamsStatsResult = {
  __typename?: 'StreamsStatsResult';
  buckets: Array<TimeBucket>;
  topStreams: Array<StreamPostCount>;
  total: Scalars['Int']['output'];
};

export type StripeBankAccount = Node & {
  __typename?: 'StripeBankAccount';
  bankName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
};

export const StripeBillingInterval = {
  Month: 'MONTH',
  Year: 'YEAR'
} as const;

export type StripeBillingInterval = typeof StripeBillingInterval[keyof typeof StripeBillingInterval];
export type StripeBillingPortalSession = {
  __typename?: 'StripeBillingPortalSession';
  url: Scalars['String']['output'];
};

export type StripeCard = Node & {
  __typename?: 'StripeCard';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
};

export type StripePayoutMethod = StripeBankAccount | StripeCard;

export type StripePrice = {
  __typename?: 'StripePrice';
  amount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  interval: StripeBillingInterval;
  intervalCount: Scalars['Int']['output'];
};

export type StripePriceInput = {
  annualPrice: Scalars['Int']['input'];
  monthlyPrice: Scalars['Int']['input'];
  quarterlyPrice: Scalars['Int']['input'];
  semiAnnualPrice: Scalars['Int']['input'];
};

export const StripePriceType = {
  OneTime: 'ONE_TIME',
  Recurring: 'RECURRING'
} as const;

export type StripePriceType = typeof StripePriceType[keyof typeof StripePriceType];
export type StripeProduct = {
  __typename?: 'StripeProduct';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type StripeSellerAccount = {
  __typename?: 'StripeSellerAccount';
  id: Scalars['String']['output'];
  onboardingUrl: Scalars['String']['output'];
  props: StripeSellerAccountProps;
};


export type StripeSellerAccountOnboardingUrlArgs = {
  page?: OnboardingLinkPage;
  queryParams?: InputMaybe<Scalars['String']['input']>;
};

export type StripeSellerAccountProps = {
  __typename?: 'StripeSellerAccountProps';
  chargesEnabled: Scalars['Boolean']['output'];
  detailsSubmitted: Scalars['Boolean']['output'];
  documentsRequired: Scalars['Boolean']['output'];
  payoutMethods: Array<StripePayoutMethod>;
  payoutsEnabled: Scalars['Boolean']['output'];
};

export type SubmitVoxFullAccessRequestInput = {
  confirmMonitoringAudit: Scalars['Boolean']['input'];
  confirmNoMisuse: Scalars['Boolean']['input'];
  investigationDetails: Scalars['String']['input'];
  legitimateNeed: Scalars['String']['input'];
  purpose: Scalars['String']['input'];
  useCase: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  onCustomCollectionPostUpdate?: Maybe<CustomCollectionPostUpdate>;
  onNotification?: Maybe<Notification>;
  streamPostsUpdates: StreamPost;
  tournamentPostsUpdates?: Maybe<TournamentPost>;
};


export type SubscriptionOnCustomCollectionPostUpdateArgs = {
  collectionId: Scalars['ID']['input'];
  streamDeckId: Scalars['ID']['input'];
};


export type SubscriptionStreamPostsUpdatesArgs = {
  streamId: Scalars['ID']['input'];
};


export type SubscriptionTournamentPostsUpdatesArgs = {
  tournamentId: Scalars['ID']['input'];
};

export type SubscriptionCheckout = {
  __typename?: 'SubscriptionCheckout';
  url: Scalars['String']['output'];
};

export type TerminalSettings = {
  __typename?: 'TerminalSettings';
  /** Enable double click on orderbook to place trade */
  enableOrderbookDoubleClick: Scalars['Boolean']['output'];
  /** Max slippage in percent for crypto trades */
  maxSlippage?: Maybe<Scalars['Float']['output']>;
  /** When the user finished or skipped the first-run onboarding flow. Null means onboarding has not been completed yet. */
  onboardingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Global filters for markets shown on stream/news lists */
  streamListFilters: StreamListFilters;
};

export type TerminalTab = Node & {
  __typename?: 'TerminalTab';
  configuration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TimeBucket = {
  __typename?: 'TimeBucket';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type ToggleFollowUserButton = {
  __typename?: 'ToggleFollowUserButton';
  user: User;
};

export type Tournament = Node & {
  __typename?: 'Tournament';
  awards: Array<Award>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deadline?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<FieldDefinition>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<S3Object>;
  label: Scalars['String']['output'];
  listPriority: Scalars['Int']['output'];
  managedBy?: Maybe<User>;
  medals: Array<Medal>;
  mySubmissions: Array<TournamentPost>;
  name: Scalars['String']['output'];
  participants: TournamentParticipantsPage;
  participantsCount: Scalars['Int']['output'];
  rules?: Maybe<Scalars['String']['output']>;
  state: TournamentState;
  submissions: TournamentPostsPage;
  submissionsCount: Scalars['Int']['output'];
};


export type TournamentParticipantsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type TournamentSubmissionsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type TournamentInput = {
  awards?: InputMaybe<Array<AwardInput>>;
  category?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<FieldDefinitionInput>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<S3ObjectInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  listPriority?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<TournamentState>;
};

export type TournamentMedal = {
  __typename?: 'TournamentMedal';
  medal: Medal;
  tournaments: Array<Tournament>;
};

export type TournamentParticipant = Node & {
  __typename?: 'TournamentParticipant';
  id: Scalars['ID']['output'];
  submissionsCount: Scalars['Int']['output'];
  user: User;
};

export type TournamentParticipantsPage = {
  __typename?: 'TournamentParticipantsPage';
  items: Array<TournamentParticipant>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type TournamentPost = Node & {
  __typename?: 'TournamentPost';
  author: User;
  authorId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  fields: Array<FieldValue>;
  id: Scalars['ID']['output'];
  repostId?: Maybe<Scalars['ID']['output']>;
  tournament: Tournament;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type TournamentPostInput = {
  fields: Array<FieldValueInput>;
  tournamentId: Scalars['ID']['input'];
};

export type TournamentPostsPage = {
  __typename?: 'TournamentPostsPage';
  items: Array<TournamentPost>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type TournamentSearchFilters = {
  category?: InputMaybe<Scalars['String']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<TournamentState>;
};

export const TournamentSortOption = {
  EndingSoon: 'ENDING_SOON',
  Priority: 'PRIORITY'
} as const;

export type TournamentSortOption = typeof TournamentSortOption[keyof typeof TournamentSortOption];
export const TournamentState = {
  Active: 'ACTIVE',
  Draft: 'DRAFT',
  Final: 'FINAL',
  Preliminary: 'PRELIMINARY',
  Processing: 'PROCESSING'
} as const;

export type TournamentState = typeof TournamentState[keyof typeof TournamentState];
export type TournamentWinner = Node & {
  __typename?: 'TournamentWinner';
  id: Scalars['ID']['output'];
  medal: Medal;
  submissionsCount: Scalars['Int']['output'];
  tournament: Tournament;
  user: User;
};

export type TournamentsPage = {
  __typename?: 'TournamentsPage';
  items: Array<Tournament>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type TwttrApiAccount = {
  __typename?: 'TwttrApiAccount';
  availableTwttrApiUnits: Scalars['BigInt']['output'];
  consumedTwttrApiUnits: Scalars['BigInt']['output'];
  purchasedTwttrApiUnits: Scalars['BigInt']['output'];
};

export type TwttrApiBillingPortalSession = {
  __typename?: 'TwttrApiBillingPortalSession';
  url: Scalars['String']['output'];
};

export type TwttrApiCheckout = {
  __typename?: 'TwttrApiCheckout';
  url: Scalars['String']['output'];
};

export type TwttrApiCheckoutPriceInput = {
  priceId: Scalars['String']['input'];
  /** The quantity of the price to checkout */
  quantity: Scalars['Int']['input'];
};

export type TwttrApiPrice = {
  __typename?: 'TwttrApiPrice';
  amount: Scalars['Int']['output'];
  apiRequestUnits: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  product: StripeProduct;
  type: StripePriceType;
};

export type TwttrApiSubscription = {
  __typename?: 'TwttrApiSubscription';
  ended_at?: Maybe<Scalars['DateTime']['output']>;
  price: TwttrApiPrice;
  start_date: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export type TypeaheadInput = {
  followingFirst: Scalars['Boolean']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  ownedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  paidFirst: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
  type: Array<SearchType>;
};

export type TypeaheadResult = {
  __typename?: 'TypeaheadResult';
  offset?: Maybe<Scalars['Int']['output']>;
  regularPosts: Array<RegularPost>;
  streamPackages: Array<StreamPackage>;
  streams: Array<Stream>;
  tournaments: Array<Tournament>;
  users: Array<User>;
};

export type UpdateCustomCollectionInput = {
  filters: CustomCollectionFilterConfigInput;
  highlights?: InputMaybe<CustomCollectionHighlightInput>;
  id: Scalars['ULID']['input'];
  name: Scalars['String']['input'];
  sources: Array<CustomCollectionSourceInput>;
  streamDeckId: Scalars['ULID']['input'];
};

export type UpdateGeneralNotificationSettingsInput = {
  notificationType: NotificationType;
  value: Scalars['Boolean']['input'];
};

export type UpdatePostInput = {
  json?: InputMaybe<Scalars['String']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<S3ObjectInput>>;
  text: Scalars['String']['input'];
};

export type UpdateSettingsInput = {
  notifications: NotificationsSettingsInput;
};

export type UpdateStreamDeckInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateStreamInput = {
  apiAccessEnabled: Scalars['Boolean']['input'];
  customTargetsData?: InputMaybe<CustomTargetsDataInput>;
  /** @deprecated use descriptionJson instead */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionJson?: InputMaybe<Scalars['LexicalJSON']['input']>;
  image?: InputMaybe<S3ObjectInput>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  packageOnly?: Scalars['Boolean']['input'];
  paidData?: InputMaybe<PaidDataInput>;
  streamCategory: StreamCategory;
};

export type UpdateStreamPackageInput = {
  badge: StreamPackageBadge;
  /** @deprecated use descriptionJson instead */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionJson?: InputMaybe<Scalars['LexicalJSON']['input']>;
  includedStreamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paidData?: InputMaybe<PaidDataInput>;
  streamPackageCategory: StreamCategory;
};

export type UpdateTerminalSettingsInput = {
  enableOrderbookDoubleClick?: InputMaybe<Scalars['Boolean']['input']>;
  maxSlippage?: InputMaybe<Scalars['Float']['input']>;
  onboardingCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  streamListFilters?: InputMaybe<StreamListFiltersInput>;
};

export type UpdateTerminalTabInput = {
  configuration?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  avatar?: InputMaybe<S3ObjectInput>;
  backgroundImage?: InputMaybe<S3ObjectInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isOnboardingFinished?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingProgress?: InputMaybe<Array<OnboardingType>>;
};

export type UpsertEnrichmentServiceInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxResponseBytes?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  secretArn?: InputMaybe<Scalars['String']['input']>;
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};

export type User = Node & {
  __typename?: 'User';
  acceptedPrivacyPolicy: Scalars['Boolean']['output'];
  acceptedTermsOfService: Scalars['Boolean']['output'];
  avatar?: Maybe<S3Object>;
  averageReputationBet: Scalars['Float']['output'];
  backgroundImage?: Maybe<S3Object>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  followersCount: Scalars['Int']['output'];
  following: Scalars['Boolean']['output'];
  followingCount: Scalars['Int']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isHighlighted: Scalars['Boolean']['output'];
  /** Whether the user is in the EarlyAccess_Terminal GrowthBook group. Admin-only, null otherwise. */
  isInEarlyAccessTerminal?: Maybe<Scalars['Boolean']['output']>;
  medals: Array<TournamentMedal>;
  medalsCount: Scalars['Int']['output'];
  organization?: Maybe<OrganizationObject>;
  organizationRole?: Maybe<OrganizationRoles>;
  posts: PostsPage;
  postsCount: Scalars['Int']['output'];
  protectedFields?: Maybe<ProtectedUserFields>;
  reputationScoresHistory: UserScoresHistoryPage;
  settings?: Maybe<UserSettings>;
  streams: StreamsPage;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  subscribedToUserPosts: Scalars['Boolean']['output'];
  terminalAccessRequested?: Maybe<Scalars['Boolean']['output']>;
  totalDownvotesReceived: Scalars['Int']['output'];
  totalUpvotesReceived: Scalars['Int']['output'];
  username: Scalars['String']['output'];
  xComHandle?: Maybe<Scalars['String']['output']>;
};


export type UserPostsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type UserReputationScoresHistoryArgs = {
  limit?: Scalars['Int']['input'];
  resolution?: ScoreHistoryResolution;
};


export type UserStreamsArgs = {
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type UserCoupon = {
  __typename?: 'UserCoupon';
  couponId: Scalars['String']['output'];
  discountAmountCents: Scalars['Int']['output'];
  streamId: Scalars['String']['output'];
  usedAt?: Maybe<Scalars['String']['output']>;
};

export type UserScoreHistoryItem = {
  __typename?: 'UserScoreHistoryItem';
  datetime: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type UserScoresHistoryPage = {
  __typename?: 'UserScoresHistoryPage';
  items: Array<UserScoreHistoryItem>;
  resolution: ScoreHistoryResolution;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  notifications: NotificationsSettings;
};

export type UsersListInput = {
  hasStripe?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPage = {
  __typename?: 'UsersPage';
  items: Array<User>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export const ValidationStatus = {
  Accepted: 'ACCEPTED',
  Rejected: 'REJECTED'
} as const;

export type ValidationStatus = typeof ValidationStatus[keyof typeof ValidationStatus];
export const VoxAccessRequestStatus = {
  Approved: 'APPROVED',
  Pending: 'PENDING',
  Rejected: 'REJECTED'
} as const;

export type VoxAccessRequestStatus = typeof VoxAccessRequestStatus[keyof typeof VoxAccessRequestStatus];
export const VoxActionType = {
  Message: 'MESSAGE',
  Reaction: 'REACTION'
} as const;

export type VoxActionType = typeof VoxActionType[keyof typeof VoxActionType];
export type VoxConfig = {
  __typename?: 'VoxConfig';
  freeAllowedUsernames: Array<Scalars['String']['output']>;
  prices: Array<VoxPrice>;
  trialAllowedUsernames: Array<Scalars['String']['output']>;
};

export const VoxContentType = {
  Contact: 'CONTACT',
  File: 'FILE',
  Geo: 'GEO',
  Media: 'MEDIA',
  Poll: 'POLL',
  Sticker: 'STICKER',
  Text: 'TEXT',
  Video: 'VIDEO',
  Voice: 'VOICE'
} as const;

export type VoxContentType = typeof VoxContentType[keyof typeof VoxContentType];
export type VoxFullAccessRequest = {
  __typename?: 'VoxFullAccessRequest';
  confirmMonitoringAudit: Scalars['Boolean']['output'];
  confirmNoMisuse: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  investigationDetails: Scalars['String']['output'];
  legitimateNeed: Scalars['String']['output'];
  purpose: Scalars['String']['output'];
  reviewedAt?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  status: VoxAccessRequestStatus;
  useCase: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type VoxFullAccessRequestsPage = {
  __typename?: 'VoxFullAccessRequestsPage';
  items: Array<VoxFullAccessRequest>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export const VoxHistoryEvent = {
  TextSearch: 'TEXT_SEARCH',
  UserNamesSearch: 'USER_NAMES_SEARCH',
  UserSearch: 'USER_SEARCH'
} as const;

export type VoxHistoryEvent = typeof VoxHistoryEvent[keyof typeof VoxHistoryEvent];
export type VoxHistoryInput = {
  event: VoxHistoryEvent;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type VoxHistoryObject = {
  __typename?: 'VoxHistoryObject';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  query: Scalars['String']['output'];
  user: User;
};

export type VoxHistoryPage = {
  __typename?: 'VoxHistoryPage';
  items: Array<VoxHistoryObject>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export const VoxMessageType = {
  Comment: 'COMMENT',
  Post: 'POST'
} as const;

export type VoxMessageType = typeof VoxMessageType[keyof typeof VoxMessageType];
export const VoxMessageTypeInput = {
  All: 'ALL',
  Comment: 'COMMENT',
  Post: 'POST'
} as const;

export type VoxMessageTypeInput = typeof VoxMessageTypeInput[keyof typeof VoxMessageTypeInput];
export type VoxPrice = {
  __typename?: 'VoxPrice';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  productType: VoxProductType;
};

export const VoxProductType = {
  Free: 'FREE',
  Full: 'FULL',
  Trial: 'TRIAL'
} as const;

export type VoxProductType = typeof VoxProductType[keyof typeof VoxProductType];
export const VoxSearchTextOrder = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type VoxSearchTextOrder = typeof VoxSearchTextOrder[keyof typeof VoxSearchTextOrder];
export type VoxSubscription = {
  __typename?: 'VoxSubscription';
  active: Scalars['Boolean']['output'];
  cancelAt?: Maybe<Scalars['String']['output']>;
  fullAccessApproved: Scalars['Boolean']['output'];
  productType: VoxProductType;
  textSearch: VoxProductType;
  userNameSearch: VoxProductType;
  userSearch: VoxProductType;
};

export type VoxTextSearchInput = {
  excludeForwards?: Scalars['Boolean']['input'];
  excludeGroupsIds?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  messageType?: VoxMessageTypeInput;
  offset?: Scalars['Int']['input'];
  onlyWithMedia?: Scalars['Boolean']['input'];
  order?: VoxSearchTextOrder;
  query: Scalars['String']['input'];
  stream?: Scalars['Boolean']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type VoxTextSearchResult = {
  __typename?: 'VoxTextSearchResult';
  count: Scalars['Int']['output'];
  messages: Array<VoxTextSearchResultEntry>;
};

export type VoxTextSearchResultEntry = {
  __typename?: 'VoxTextSearchResultEntry';
  date: Scalars['String']['output'];
  groupAlias: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  groupMembersCount: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  groupUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  messageUrl: Scalars['String']['output'];
  relatedGroupAlias: Scalars['String']['output'];
  relatedGroupId: Scalars['String']['output'];
  relatedGroupMembersCount: Scalars['String']['output'];
  relatedGroupName: Scalars['String']['output'];
  relatedGroupUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: VoxMessageType;
  userAlias: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type VoxUserNamesEntry = {
  __typename?: 'VoxUserNamesEntry';
  alias: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VoxUserNamesSearchResult = {
  __typename?: 'VoxUserNamesSearchResult';
  names: Array<VoxUserNamesEntry>;
};

export type VoxUserProfileActionMessage = {
  __typename?: 'VoxUserProfileActionMessage';
  content: VoxUserProfileMessageContent;
  date: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  type: VoxActionType;
};

export type VoxUserProfileActionUnion = VoxUserProfileActionMessage | VoxUserProfileReaction;

export type VoxUserProfileGroup = {
  __typename?: 'VoxUserProfileGroup';
  about: Scalars['String']['output'];
  alias: Scalars['String']['output'];
  id: Scalars['String']['output'];
  membersCount: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VoxUserProfileMessageContent = {
  __typename?: 'VoxUserProfileMessageContent';
  contentType: VoxContentType;
  id: Scalars['String']['output'];
  reactions: Array<VoxUserProfileReaction>;
  text: Scalars['String']['output'];
};

export type VoxUserProfileReaction = {
  __typename?: 'VoxUserProfileReaction';
  count: Scalars['Int']['output'];
  emoji: Scalars['String']['output'];
};

export type VoxUserProfileResult = {
  __typename?: 'VoxUserProfileResult';
  about: Scalars['String']['output'];
  accountAge: Scalars['Int']['output'];
  actions: Array<VoxUserProfileActionUnion>;
  alias: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  groups: Array<VoxUserProfileGroup>;
  id: Scalars['String']['output'];
  pic: Scalars['String']['output'];
};

export type VoxUserSearchInput = {
  userNameOrUserId: Scalars['String']['input'];
};
